export default __webpack_public_path__ + "static/sOliverCase-MediumWeb-05e8a6d50503e2b7432035af0b614862.woff";